import { Button, Column, Modal, Row } from "../../../../../widget";

interface ResumeDraftDealModalProps {
  showDraftModal: boolean;
  handleUseDraft: () => void;
  onClose: () => void;
}

export const ResumeDraftDealModal = ({
  showDraftModal,
  handleUseDraft,
  onClose,
}: ResumeDraftDealModalProps): JSX.Element => {
  return (
    <Modal show={showDraftModal} title="Resume draft deal?" onClose={onClose}>
      <Row justify="center" spacingV="l">
        <Column span={10}>
          <span className="body1">
            You hava a saved draft deal from a previous session. Would you like to continue where you left off or start
            a new deal? Starting a new deal will discard the draft.
          </span>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <div className="NewDealJourneyDraftModalButtons">
            <Button text="Use draft" onClick={handleUseDraft} />
            <Button text="Start new deal" variant="secondary" onClick={onClose} />
          </div>
        </Column>
      </Row>
    </Modal>
  );
};
